<div class="game-effectiveness-container">
    <div class="header">
        <h2 cvLocalizedText langSection="Game_Health_Report" langKey="Game_Effectiveness">Game Effectiveness</h2>
    </div>
    <div class="effectiveness-container">
        <div class="canvas-container position-relative">
            <div *ngIf="isLoading || isLoadingGameParams">
                <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
            </div>
            <canvas *ngIf="!isLoading" baseChart  class="chart-effectiveness-container"
                [type]="chartType" 
                [data]="chartData" 
                [options]="chartOptions">
            </canvas>
        </div>

        <div class="stats-container">
            <div class="metric-selector" *ngIf="metricList.length > 1">
                <ng-container *ngIf="metricList.length > 1">
                    <select class="form-control select-rounds w-full mb-2" [disabled]="isLoading"
                        [(ngModel)]="gameMetric" (ngModelChange)="onMetricSelectionChange()">
                        <option *ngFor="let option of metricList" [ngValue]="option">{{ option.MetricDetail.Abbrev }}
                        </option>
                    </select>
                </ng-container>
            </div>

            <h2 *ngIf="gameMetric" class="title">{{ gameMetric.MetricDetail?.Abbrev }}</h2>

            <div *ngIf="gameMetric">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Metric_Direction" class="period-title">
                    Metric Direction</h3>
                <p class="date">{{ metricDirection }}</p>
            </div>

            <div class="period-section">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Game_Period" class="period-title">Game
                    Period</h3>
                <p class="date">{{ gamePeriod }}</p>
                <p class="average">
                    <span cvLocalizedText langSection="Game_Health_Report" langKey="Average">Avg. </span>{{
                    gamePeriodAvg }}
                    <span [class]="getStyleClass()">{{ calculateDifference() }}</span>
                </p>
            </div>

            <div class="period-section">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Previous_Period" class="period-title">
                    Previous Period</h3>
                <p class="date">{{ previousPeriod }}</p>
                <p class="average">
                    <span cvLocalizedText langSection="Game_Health_Report" langKey="Average">Avg. </span>{{
                    previousPeriodAvg }}
                </p>
            </div>
        </div>

    </div>
</div>